import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Sticky next-action strip on open docs — plan/35 D.
 * Mount under header / above tab body so Collect·Deliver·Pay stay findable.
 */
export function DeskDocActionRail(props: {
  children: ReactNode;
  className?: string;
  label?: string;
}) {
  return (
    <div
      className={cn(
        "sticky top-[var(--desk-sticky-offset,0px)] z-10 -mx-1 mb-4 flex flex-wrap items-center gap-2 rounded-[var(--radius-xl)] border border-[var(--color-border)]/90 bg-[var(--color-card)]/95 px-3 py-2.5 shadow-[var(--shadow-soft)] backdrop-blur-sm",
        props.className,
      )}
      role="region"
      aria-label={props.label ?? "Next actions"}
    >
      {props.children}
    </div>
  );
}
